<template>
    <div class="uk-position-relative uk-grid-large" uk-grid>
        <loader :visible="showLoader"></loader>
        <div :class="{'uk-width-2-3@m': !isLastStep, 'uk-width-1-1@m': isLastStep}">
            <div class="uk-margin-large-bottom">
                <rubinred-checkout-progress-bar :cart="cart" :steps="steps" :step="step"></rubinred-checkout-progress-bar>
            </div>
            <div class="rr-checkout">
                <slot name="steps" :cart="cart"></slot>
                <div class="rr-checkout__step-nav uk-margin-medium-top uk-grid-small uk-flex-right" uk-grid v-show="! isLastStep">
                    <div class="uk-width-1-2@s uk-text-right@s">
                        <button type="submit" class="uk-width-1-1 uk-width-auto@s uk-button uk-button-primary" @click="submitCurrentStep">
                            {{ $t('rubinred.ecommerce.orders.checkout.next') }}
                        </button>
                    </div>
                    <div class="uk-width-1-2@s uk-flex-first@s" v-show="step > 1">
                        <button type="submit" class="uk-width-1-1 uk-width-auto@s uk-button uk-button-default uk-button-hollow" @click="previousStep">
                            {{ $t('rubinred.ecommerce.orders.checkout.back') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-width-1-3@m" v-show="! isLastStep">
            <div uk-sticky="offset: 100; media: 960; bottom: true">
                <rubinred-checkout-resume :cart="cart" :cart-endpoint="cartEndpoint"></rubinred-checkout-resume>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      cartEndpoint: {
        type: String,
        required: true,
      },
      activeStep: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        progressBar: null,
        steps: [],
        step: this.activeStep,
        showLoader: false,
      };
    },
    computed: {
      cart() {
        return this.$store.state.cart.cart;
      },
      currentStep() {
        return this.steps[this.step - 1];
      },
      isLastStep() {
        return this.step === this.steps.length;
      },
    },
    created() {
      this.$root.$on('checkout.register-step', step => this.steps.push(step));
      this.$root.$on('checkout.go-to-step', this.goToStep);
      this.$root.$on('checkout.toggle-loader', this.toggleLoader);
    },
    methods: {
      submitCurrentStep() {
        let promise = this.currentStep.submit();
        if (promise) {
          this.toggleLoader();
          promise.then(({data}) => {
            if (data.success) {
              this.step++;
              window.scrollTo(0, 0);
              App.UIkit.update();
            }
            this.toggleLoader();
          });
        }
      },
      previousStep() {
        this.step--;
        window.scrollTo(0, 0);
        App.UIkit.update();
      },
      goToStep(n) {
        this.step = n;
        window.scrollTo(0, 0);
        App.UIkit.update();
      },
      toggleLoader(active = null) {
        this.showLoader = active === null ? !this.showLoader : active;
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/RubinredCheckout.vue